import Vue from "vue";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import Router from "vue-router";
import DashboardLayout from "@/layout/DashboardLayout";
import AuthLayout from "@/layout/AuthLayout";
Vue.use(Router);

const routes = [
  {
    path: "/",
    redirect: "register",
    component: DashboardLayout,
    children: [
      {
        path: "/inicio",
        name: "inicio",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Dashboard.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/tables",
        name: "tables",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Tables.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/solicitudcredito",
        name: "Solicitud de crédito",
        component: () =>
          import("./views/SolicitudCredito.vue"),
        children:[
        ],
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/solicitud-pedido",
        name: "Solicitud de pedido",
        component: () =>
          import("./views/SolicitudPedido.vue"),
        children:[
        ],
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/devoluciones",
        name: "Devoluciones",
        component: () =>
          import("./views/Devoluciones.vue"),
        children:[
        ],
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/",
    redirect: "login",
    component: AuthLayout,
    children: [
      {
        path: "/login",
        name: "login",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Login.vue"),
      },
      {
        path: "/register",
        name: "register",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Register.vue"),
      },
      {
        path: "/maintenance",
        name: "maintenance",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/MaintenanceScreen.vue"),
      },
      {
        path: "/credito",
        name: "Solicitud de crédito ",
        component: () =>
          import("./views/SolicitudCreditoLink.vue"),
        children:[
        ],
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/cotiza",
        name: "Cotizaciones",
        component: () =>
          import("./views/Cotiza.vue"),
        children:[
        ],
        meta: {
          requiresAuth: false,
        },
      },
      // {
      //   path: "/prospect",
      //   name: "Prospecto",
      //   component: () =>
      //     import("./views/Prospect.vue"),
      //   children:[
      //   ],
      //   meta: {
      //     requiresAuth: false,
      //   },
      // },
    ],
  },
];

const router = new Router({
  linkExactActiveClass: "active",
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  // console.log(currentUser)
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next("login");
  else if (!requiresAuth && currentUser) next("inicio");
  else next();
});

export default router;
